import Scriba from 'react-scriba';

export class DataCompte {

    static _onResolveSuggestions(filterText, idSociete) {
        const objet = {
            "ChaineDeRecherche": filterText,
            "IdSociete": idSociete
        };
        const url = "api/Get/GetCompteRecherche";
        const paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json())
    };

    static _chargementDesComptesDeLaSocieteDeCeTypeDeMandat(idSociete, idsTypesMandats, listeIdContacts, doitInclureComptesSansMandat) {
        const objet = {
            "idSociete": idSociete,
            "idsTypesMandats": Array.isArray(idsTypesMandats) ? idsTypesMandats : [idsTypesMandats],
            "listeIdContacts": listeIdContacts,
            "doitInclureComptesSansMandat": doitInclureComptesSansMandat
        };
        const url = "api/Liste/ListeDesCOMPTES";
        const paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }
    static _chargementDesComptesDeLaSociete(idSociete, doitInclureComptesSansMandat) {
        const objet = {
            "idSociete": idSociete,
            "doitInclureComptesSansMandat": doitInclureComptesSansMandat
        };
        const url = "api/Liste/ListeDesCOMPTES";
        const paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }
    static _chargementDesComptesEiffageDeTypeOperationnelOuGestionnaireDeMandatAyantUnMandatSurLePerimetrePasseEnParametre(idRegion, idAgence, doitInclureComptesSansMandat) {
        const objet = {
            "idSociete": 1,
            "idRegion": idRegion,
            "idAgence": idAgence,
            "doitInclureComptesSansMandat": doitInclureComptesSansMandat
        };
        const url = "api/Liste/ListeDesCOMPTES";
        const paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementDesComptesEiffageAyantUnMandatSurLePerimetreDuLotCommercialDeCeTypeDeMandat(idOperation, idLotCommercial, idsTypesMandats, doitInclureComptesSansMandat) {
        const objet = {
            "idSociete": 1,
            "idOperation": idOperation,
            "idLotCommercial": idLotCommercial,
            "idsTypesMandats": Array.isArray(idsTypesMandats) ? idsTypesMandats : [idsTypesMandats],
            "doitInclureComptesSansMandat": doitInclureComptesSansMandat
        };
        const url = "api/Liste/ListeDesCOMPTES";
        const paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementFicheCompte(loginCompte) {
        const objet = { "loginCompte": loginCompte };
        const url = "api/Get/GetCompte";
        const paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onEnregistrementCompte(compte, loginCompte) {
        const objet = {
            compte,
            loginCompte // Permet de savoir s'il s'agit d'une création ou d'une modif'
        };
        const url = "api/MAJDonnees/EnregistrementCompte";
        const paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onRegenereMotDePasse(loginCompte) {
        const objet = { "loginCompte": loginCompte };
        const url = "api/MAJDonnees/RegenerationMotDePasseCompte";
        const paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onRenseignementLoginCompte(prenom, nom) {
        const objet = {
            "prenom": prenom,
            "nom": nom,
        };
        const url = "api/MajDonnees/GenerationLoginCompte";
        const paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementDesComptesEtantProprietaireDesContacts(listeIdContacts) {
        const objet = { "listeIdContacts": listeIdContacts };
        const url = "api/Liste/ListeDesComptesEtantProprietaireDesContacts";
        const paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementMonCompte() {
        return fetch('api/Auth/ChargementMonCompte',
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({})
            }).then(response => response.json());
    }

    static _getEstAdminNational(loginCompte) {
        const objet = { "loginCompte": loginCompte };
        const url = "api/Get/GetEstAdminNational";
        const paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _chargementComptes = (filtres, sortedColumn, isSortedDescending) => {
        const objet = { filtres, sortedColumn, isSortedDescending };
        const url = "api/Liste/ListeDesComptes";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

}